/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%] {\n	height: 100%;\n	min-height: 130px;\n	display: block;\n}\n\n.app-modal-title[_ngcontent-%COMP%] {\n	height: 30%;\n}\n.app-modal-content[_ngcontent-%COMP%] {\n	height: 55%;\n	text-align: center;\n	font-size: 16px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9jb21tb24tY29uZmlybS1tb2RhbC9jb21tb24tY29uZmlybS1tb2RhbC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9jb21tb24tY29uZmlybS1tb2RhbC9jb21tb24tY29uZmlybS1tb2RhbC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/common-confirm-modal/common-confirm-modal.component.css.shim.ngstyle.ts